import styled from 'styled-components';

export const CardWrapper = styled.div`
  position: relative;
  height: 210px;
  overflow: hidden;
  padding-left: 3px;
  min-width: 150px;
  cursor: pointer;
`;
